import { guid } from '@/mixins/guid';

export function colShape(g, autoFit) {
  const desktop = g.autoFit ? 'initial' : `${g.rowStart} / ${g.colStart} / ${g.rowEnd} / ${g.colEnd}`;
  const tablet = autoFit && autoFit.tablet ? 'initial' : 'default';
  const mobile = autoFit && autoFit.mobile ? 'initial' : 'default';
  return () => ({
    _id: guid.methods.guid(),
    grid: {
      rowStart: g.rowStart,
      colStart: g.colStart,
      rowEnd: g.rowEnd,
      colEnd: g.colEnd,
    },
    removed: false,
    covered: {
      desktop: false,
      tablet: false,
      mobile: false,
    },
    mediaQueries: [{
      property: 'grid-area',
      desktop,
      tablet,
      mobile,
    }],
    droplets: [],
    pageLink: false,
    type: 'droplet.grid.column',
  });
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/grid/utils.js